const ROLES = {
    ZTUDENT: 1,
    INSTRUCTOR: 2,
    LEADER: 3,
    DISTRIBUTOR: 4
}

//PROJECT_LEADER: 3,

export { ROLES };